var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadeLogoNoname(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 194,
    viewBox: "0 0 194 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_769_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.301 0.195753C44.7563 -3.49588 -3.49588 44.7563 0.195753 103.301C3.2482 151.579 42.4213 190.752 90.6995 193.804C149.244 197.509 197.496 149.244 193.804 90.6995C190.752 42.4213 151.579 3.2482 103.301 0.195753ZM103.731 179.651C52.6352 183.682 10.3184 141.352 14.3492 90.256C17.519 50.0654 50.0915 17.493 90.2821 14.3231C141.378 10.2923 183.695 52.6092 179.664 103.705C176.494 143.896 143.935 176.468 103.731 179.638V179.651Z",
    fill: "#004AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.801 70.6239H147.639C146.844 70.6239 146.074 70.937 145.513 71.4979L94.5606 122.45C93.3866 123.624 91.4821 123.624 90.3211 122.45L86.4599 118.589C85.2859 117.415 83.3814 117.415 82.2204 118.589L75.6459 125.164C74.4719 126.338 74.4719 128.242 75.6459 129.403L90.3211 144.078C91.4951 145.252 93.3997 145.252 94.5606 144.078L103.261 135.378H103.274L162.928 75.7374C164.819 73.8459 163.475 70.6108 160.801 70.6108V70.6239Z",
    fill: "#004AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.441 70.6239H104.279C103.483 70.6239 102.714 70.937 102.153 71.4979L72.8675 100.783C71.6935 101.957 69.789 101.957 68.628 100.783L64.7668 96.9219C63.5928 95.7479 61.6883 95.7479 60.5273 96.9219L53.9528 103.496C52.7788 104.67 52.7788 106.575 53.9528 107.736L68.628 122.411C69.802 123.585 71.7065 123.585 72.8675 122.411L81.5553 113.723H81.5683L119.58 75.7374C121.472 73.8459 120.128 70.6108 117.454 70.6108L117.441 70.6239Z",
    fill: "#004AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2109 70.6239H61.0488C60.2531 70.6239 59.4835 70.937 58.9226 71.4979L51.2393 79.1812C50.0653 80.3552 48.1607 80.3552 46.9998 79.1812L43.1777 75.3591C42.0037 74.1851 40.0991 74.1851 38.9382 75.3591L32.3637 81.9336C31.1896 83.1076 31.1896 85.0121 32.3637 86.1731L47.0259 100.835C48.1999 102.009 50.1044 102.009 51.2654 100.835L59.9661 92.1345L76.3502 75.7374C78.2417 73.8459 76.8981 70.6108 74.2239 70.6108L74.2109 70.6239Z",
    fill: "#004AF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_769_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 194,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadeLogoNoname);
export default __webpack_public_path__ + "static/media/pade-logo-noname.9e6bf8a402b5709c08a1f2a430f69010.svg";
export { ForwardRef as ReactComponent };